import styled, { css } from "styled-components";
import { colors } from "styles/colors";

type ButtonStyleOption =
  | "dark"
  | "primary"
  | "secondary"
  | "transparent"
  | "cancel"
  | "warning"
  | "success"
  | "danger"
  | "info"
  | "outline";

interface ButtonStyle {
  btStyle?: ButtonStyleOption;
  disabled?: boolean;
}

const styleButton = {
  dark: css`
    background-color: ${colors.gray3};
    color: #fff;
  `,
  primary: css`
    background-color: ${colors.darkGreen};
    color: #fff;
  `,
  secondary: css`
    background-color: #1a1a1a;
    color: #fff;
  `,
  outline: css`
    background-color: transparent;
    color: #1a1a1a;
    border: 2px solid #1a1a1a;
  `,
  transparent: css`
    background-color: transparent;
    color: #1a1a1a;
    padding: 16px 0;
  `,
  cancel: css`
    background-color: ${colors.gray};
    color: ${colors.gray3};
  `,
  warning: css`
    background-color: ${colors.orange};
    color: #fff;
  `,
  danger: css`
    background-color: ${colors.red};
    color: #fff;
  `,
  info: css`
    background-color: ${colors.midBlue};
    color: #fff;
  `,
  success: css`
    background-color: ${colors.darkGreen};
    color: #fff;
  `,
};

export const Button = styled.button<ButtonStyle>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  padding: 16px 48px;
  height: 56px;
  border-radius: 4px;
  transition: 300ms ease;

  :hover {
    transform: scale(0.95);
  }

  ${({ btStyle }) => (btStyle ? styleButton[btStyle] : styleButton.primary)}
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${colors.gray}80;
      color: ${colors.gray3}40;
      cursor: not-allowed;
      :hover {
        transform: unset;
      }
    `}
`;

export const ButtonMini = styled.button<ButtonStyle>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 14px;
  transition: 300ms ease;

  :hover {
    transform: scale(0.95);
  }

  ${({ btStyle }) => (btStyle ? styleButton[btStyle] : styleButton.primary)}
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${colors.gray}80;
      color: ${colors.gray3}40;
      cursor: not-allowed;
      :hover {
        transform: unset;
      }
    `}
`;
